import React from "react";

function SocialIcons() {
  return (
    <>
      <div className="social-container">
        <ul className="social-icons">
          <li>
            <a href="/">
              <i className="fa fa-brands fa-facebook"></i>
            </a>
          </li>
          <li>
            <a href="/">
              <i className="fa fa-brands fa-instagram"></i>
            </a>
          </li>
          <li>
            <a href="/">
              <i className="fa fa-brands fa-x-twitter"></i>
            </a>
          </li>
          <li>
            <a href="/">
              <i className="fa fa-brands fa-linkedin"></i>
            </a>
          </li>
          <li>
            <a href="/">
              <i className="fa fa-brands fa-youtube-play"></i>
            </a>
          </li>           
        </ul>
      </div>

      {/* <div className="social-menu">
        <ul>
          <li>
            <Link href="/">
              <i class="fab fa-facebook-f"></i>
            </Link>
          </li>
          <li>
            <Link href="/">
              <i class="fab fa-instagram"></i>
            </Link>
          </li>
          <li>
            <Link href="/">
              <i class="fab fa-x-twitter"></i>
            </Link>
          </li>
        </ul>
      </div> */}
    </>
  );
}

export default SocialIcons;
